// Autocomplete component provides simple autocompletion for text fields.
// Use it by adding `.c-autocomplete` to the text input and providing the
// autocomplete options as a JSON array in `data-autocomplete`.
//
// For example:
//
//   <input class='c-autocomplete' data-autocomplete='[quot;one&quot;, &quot;two&quot;, &quot;three&quot;]'>
//
import Components from "../components";

class Autocomplete extends Components.Base {
  bind() {
    this.on('blur', () => setTimeout(this.hideDropdown.bind(this), 100));
    this.on('keyup', e => this.keyUp(e));
    this.on('keydown', e => this.keyDown(e));
    this.resizeFn = () => this.hideDropdown();
    $(window).on('resize', this.resizeFn);
  }

  unbind() {
    $(window).off('resize', this.resizeFn);
  }

  keyDown(e) {
    if (e.keyCode === 13) {
      // Enter - must be handled in keydown to be able to prevent form submittal
      if (this.$dropdown) {
        this.selectActive();
        this.hideDropdown();
        e.preventDefault();
      }
    }
  }

  keyUp(e) {
    if (e.keyCode === 27) {
      // Escape
      this.hideDropdown();
      this.$el.blur();
    } else if (e.keyCode === 13) {
      // Enter. Don't do anything. Handled in keydown handler
    } else if (e.keyCode === 40) {
      // Down arrow
      this.activateNext();
    } else if (e.keyCode === 38) {
      // up arrow
      this.activatePrevious();
    } else {
      this.showDropdown();
      this.updateDropdownItems();
      this.clearActive();
    }
  }

  clickItem(e) {
    this.$el.val(e.currentTarget.innerText);
    this.hideDropdown();
    e.preventDefault();
  }

  showDropdown() {
    if (!this.$dropdown) {
      this.$dropdown = $('<div class="dropdown-menu">');
      this.$dropdown.insertAfter(this.$el).show();

      const pos = this.$el.position();
      this.$dropdown.css({
        top: pos.top + this.$el.height() + 10,
        left: pos.left,
        width: this.$el.width(),
        'max-height': 200,
        overflow: 'auto',
      });

      this.$dropdown.on('click', 'a.dropdown-item', e => this.clickItem(e));
    }
  }

  hideDropdown() {
    if (this.$dropdown) {
      this.$dropdown.remove();
      this.$dropdown = null;
    }
  }

  matches() {
    const val = this.$el.val().toLowerCase();
    if (val.length === 0) {
      return [];
    }
    const items = this.$el.data('autocomplete');
    return items.filter(x => x.toLowerCase().startsWith(val));
  }

  updateDropdownItems() {
    if (this.$dropdown) {
      const matches = this.matches();
      if (matches.length === 0) {
        this.hideDropdown();
      } else {
        this.$dropdown.empty();
        matches.forEach(item => {
          this.$dropdown.append(
            $(`<a class="dropdown-item" href="#">${item}</a>`),
          );
        });
      }
    }
  }

  selectActive() {
    if (this.$dropdown) {
      const active = this.$dropdown.find('.dropdown-item.active')[0];
      if (active) {
        this.$el.val(active.innerText);
      }
    }
  }

  clearActive() {
    if (this.$dropdown) {
      this.$dropdown.find('.dropdown-item.active').removeClass('active');
    }
  }

  activateFirst() {
    if (this.$dropdown) {
      const results = this.$dropdown.find('.dropdown-item');
      $(results[0]).addClass('active');
    }
  }

  activateNext() {
    if (this.$dropdown) {
      const active = this.$dropdown.find('.dropdown-item.active');
      if (active.length > 0) {
        const next = $(active)
          .nextAll('.dropdown-item')
          .first();

        if (next.length > 0) {
          next.addClass('active');
          $(active).removeClass('active');
        }
      } else {
        this.activateFirst();
      }
    }
  }

  activatePrevious() {
    if (this.$dropdown) {
      const active = this.$dropdown.find('.dropdown-item.active');
      if (active.length > 0) {
        const prev = $(active)
          .prevAll('.dropdown-item')
          .first();
        if (prev.length > 0) {
          prev.addClass('active');
          $(active).removeClass('active');
        }
      }
    }
  }
}

Components.collection.register({
  selector: '.c-autocomplete',
  klass: Autocomplete,
});
